<template>
    <v-container class="pa-5" fluid>
        <page-title>{{ pageTitle }}</page-title>

        <v-row tag="form">
            <v-col cols="12">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12">
                            <v-card>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="3">
                                            <v-text-field
                                                v-model="externalRequest.receiverEmail"
                                                :disabled="actionLoading"
                                                :error-messages="externalRequestReceiverEmailErrors"
                                                label="E-mail dostawcy"
                                            />
                                        </v-col>
                                        <v-col cols="12" sm="3">
                                            <v-text-field
                                                v-model="externalRequest.ccEmail"
                                                :disabled="actionLoading"
                                                :error-messages="externalRequestCcErrors"
                                                label="DW"
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12" lg="3">
                                            <v-text-field
                                                v-model="externalRequest.title"
                                                label="Tytuł wiadomości"
                                                :error-messages="externalRequestTitleErrors"
                                                required
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <v-textarea
                                                v-model="externalRequest.content"
                                                label="Treść wiadomości"
                                                :error-messages="contentErrors"
                                                required
                                            />
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="actionName === 'createExternalRequest'">
                                        <v-col cols="12" lg="6">
                                            <v-select
                                                v-model="externalRequest.external_attachment"
                                                :items="files"
                                                item-value="id"
                                                item-text="file"
                                                no-data-text="Nie znaleziono plików"
                                                label="Pliki"
                                                multiple
                                                required
                                            >
                                                <template #selection="data">
                                                    <v-chip
                                                        close
                                                        @update:active="removeFile()"
                                                    >
                                                        {{ formatName(data.item) }}
                                                    </v-chip>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="actionName === 'createExternalRequest'">
                                        <v-col cols="12" lg="4">
                                            <v-select
                                                v-model="externalRequest.comments"
                                                :items="request.comment"
                                                item-value="id"
                                                item-text="comment"
                                                return-object
                                                no-data-text="Nie znaleziono komentarzy"
                                                label="Komentarze"
                                                multiple
                                                required
                                            >
                                                <template #selection="data">
                                                    <v-chip
                                                        close
                                                        @update:active="removeProperty(data.item)"
                                                    >
                                                        {{ data.item.comment }}
                                                    </v-chip>
                                                </template>
                                            </v-select>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-card v-if="externalRequest.comments.length > 0">
                                <v-list rounded>
                                    <v-col cols="12">
                                        <h4 class="text-h6">
                                            Komentarze:
                                        </h4>
                                    </v-col>
                                    <v-list-item-group color="primary">
                                        <v-list-item
                                            v-for="(item, i) in externalRequest.comments"
                                            :key="i"
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title v-text="formatComment(item)" />
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card>
                            <v-card-text v-else>
                                <v-alert
                                    type="info"
                                    text
                                    border="left"
                                >
                                    Brak komentarzy dla zapotrzebowania.
                                </v-alert>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-row v-if="actionName === 'readExternalRequest'">
                        <v-col cols="12">
                            <v-card v-if="uploadedFiles.length > 0">
                                <v-list rounded>
                                    <v-col cols="12">
                                        <h4 class="text-h6">
                                            Pliki:
                                        </h4>
                                    </v-col>
                                    <v-list-item-group color="primary">
                                        <v-list-item
                                            v-for="(externalAttachment, index) in uploadedFiles"
                                            :key="index"
                                        >
                                            <v-list-item-title>
                                                {{ formatExternalAttachmentName(externalAttachment) }}
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Pobierz"
                                                    @click="openInNewTab(externalAttachment)"
                                                >
                                                    <v-icon>mdi-download</v-icon>
                                                </v-btn>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list-item-group>
                                </v-list>
                            </v-card>
                            <v-card-text v-else>
                                <v-alert
                                    type="info"
                                    text
                                    border="left"
                                >
                                    Brak plików dla zapotrzebowania.
                                </v-alert>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-btn
                                color="error"
                                medium
                                class="mr-3"
                                data-sentry-label="Anuluj"
                                :disabled="requestLoading"
                                @click="close"
                            >
                                Anuluj
                            </v-btn>
                            <v-btn
                                v-if="actionName === 'createExternalRequest'"
                                color="success"
                                medium
                                class="mr-3"
                                data-sentry-label="Zapisz"
                                :loading="requestLoading"
                                @click="saveExternalRequest"
                            >
                                Zapisz
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import store from '@/./store'
import { apiConfig } from '@/config'
import PageTitle from '@/components/common/PageTitle'
import dateFormatter from '@/mixins/dateFormatter'
import { errorHandler } from '@/utils/errorHandler'
import { required, email } from 'vuelidate/lib/validators'

export default {
    name: 'ExternalRequest',
    components: {
        PageTitle
    },
    mixins: [ dateFormatter ],
    beforeRouteEnter(to, from, next) {
        if (to.params.requestId) {
            store.dispatch('purchases/getRequest', to.params.requestId)
                .then(response => {
                    next(vm => {
                        vm.request = Object.assign({}, response.data)
                        vm.request.deliveryDate = response.data.deliveryDate ? (response.data.deliveryDate).substring(0, 10) : response.data.deliveryDate
                        vm.actionName = 'createExternalRequest'
                        vm.pageTitle = `Zapotrzebowanie / Nowe zapytanie dla zapotrzebowania ${response.data.id}`
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        }
        if (to.params.externalRequestId) {
            store.dispatch('purchases/getExternalRequest', to.params.externalRequestId)
                .then(response => {
                    next(vm => {
                        vm.externalRequest = Object.assign({}, response.data)
                        vm.actionName = 'readExternalRequest'
                        vm.pageTitle = `Zapotrzebowanie / Zapytanie ${vm.externalRequest.id} dla zapotrzebowania ${vm.externalRequest.request}`
                    })
                })
                .catch(error => {
                    next(error)
                    errorHandler(error)
                })
        }
    },
    data() {
        return {
            pageTitle: '',
            request: {},
            requestLoading: false,
            actionLoading: false,
            externalRequest: {
                title: null,
                content: null,
                receiverEmail: null,
                ccEmail: null,
                external_attachment: [],
                comments:[]
            },
            uploadedFiles: [],
            files: [],
            comments: [],
            content: [],
            actionName: null,
        }
    },
    computed: {
        externalRequestCcErrors() {
            const errors = []

            if (!this.$v.externalRequest.ccEmail.$dirty) return errors
            !this.$v.externalRequest.ccEmail.required && errors.push('DW jest wymagane.')
            !this.$v.externalRequest.ccEmail.email && errors.push('Niepoprawny format.')

            return errors
        },
        externalRequestReceiverEmailErrors() {
            const errors = []

            if (!this.$v.externalRequest.receiverEmail.$dirty) return errors
            !this.$v.externalRequest.receiverEmail.required && errors.push('Email jest wymagany.')
            !this.$v.externalRequest.receiverEmail.email && errors.push('Niepoprawny format.')

            return errors
        },
        externalRequestTitleErrors() {
            const errors = []

            if (!this.$v.externalRequest.title.$dirty) return errors
            !this.$v.externalRequest.title.required && errors.push('Tytuł wiadomości jest wymagany.')

            return errors
        },
        contentErrors() {
            const errors = []

            if (!this.$v.externalRequest.content.$dirty) return errors
            !this.$v.externalRequest.content.required && errors.push('Treść wiadomości jest wymagana.')

            return errors
        },
    },
    validations() {
        return {
            externalRequest: {
                title: {
                    required
                },
                receiverEmail: {
                    required,
                    email
                },
                ccEmail: {
                    required,
                    email
                },
                content: {
                    required
                },
            },
        }
    },
    watch: {
        externalRequest() {
            this.createUploadedUrls()
        }
    },
    created() {
        this.createFilesUrls()
    },
    methods: {
        createFilesUrls() {
            this.files = []
            this.$store.state.purchases.requests.requestAttachments.forEach(function(item) {
                let file = {
                    id : item.id,
                    file: item.file.split('/')[item.file.split('/').length -1],
                }

                this.files.push(file)
            }, this)
        },
        removeFile(item) {
            this.externalRequest.external_attachment.splice(this.externalRequest.external_attachment.indexOf(item), 1)
        },
        removeProperty(item) {
            this.externalRequest.comments.splice(this.externalRequest.comments.indexOf(item), 1)
            this.comments.splice(this.comments.indexOf(item.id), 1)
        },
        formatCreatedBy(value) {
            if (value.firstName && value.lastName) {
                return `${value.firstName} ${value.lastName}`
            }

            return value.username
        },
        formatComment(item) {
            return `${this.formatDate(item.createdAt)} - ${this.formatCreatedBy(item.createdBy)} - ${item.comment}`
        },
        formatName(value) {
            const attachmentUrl = value.file.split('/')

            return attachmentUrl[attachmentUrl.length - 1]
        },
        createUploadedUrls() {
            this.uploadedFiles = []
            const mediaRoot = apiConfig.FACTORYBASE_API_URI

            this.externalRequest.external_attachment.forEach(function(item) {
                let file = {
                    id : item.id,
                    file: mediaRoot + item.file,
                }

                this.uploadedFiles.push(file)
            }, this)
        },
        saveExternalRequest() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                this.$store.dispatch('showNotification', {
                    type: 'error',
                    message: this.$i18n.t('validations.invalidMessage')
                })
            } else {
                this.externalRequest.comments.forEach(item => this.comments.push(item.id))
                this.requestLoading = true

                this.$store.dispatch('purchases/createExternalRequest', {
                    requestId: this.request.id,
                    external_attachment: this.externalRequest.external_attachment,
                    title: this.externalRequest.title,
                    content: this.externalRequest.content,
                    comments: this.comments,
                    receiverEmail: this.externalRequest.receiverEmail,
                    ccEmail: this.externalRequest.ccEmail
                })
                    .catch(error => {
                        errorHandler(error)
                    })
                    .finally(() => {
                        this.close()
                    })
            }
        },
        close() {
            this.requestLoading = false
            if (this.actionName === 'readExternalRequest') {
                this.$router.push({ name: 'purchasesRequestsEdit', params: { id: this.externalRequest.request } })
                    .catch(error => {
                        errorHandler(error)
                    })
            } else {
                this.$router.push({ name: 'purchasesRequests' })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
            this.$v.$reset()
        },
        formatExternalAttachmentName(value) {
            const attachmentUrl = value.file.split('/')

            return attachmentUrl[attachmentUrl.length - 1]
        },
        openInNewTab(url) {
            window.open(url.file, '_blank').focus()
        },
    }

}
</script>

